import { motion } from 'motion/react';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import styled from 'styled-components';

import { Flex } from '../../grid';
import { P } from '../../typography/new';
import { usePrevious } from '../../../hooks/use-previous';

const AddedToOrderToast = () => {
  const { CartStore } = useRootStore();
  const [isToastVisible, setIsToastVisible] = useState(false);

  const { itemCount } = CartStore;
  const previousItemCount = usePrevious(itemCount);

  useEffect(() => {
    if (itemCount > previousItemCount) {
      setIsToastVisible(true);
    }

    const timer = setTimeout(() => {
      setIsToastVisible(false);
    }, 1600);

    return () => clearTimeout(timer);
  }, [itemCount, previousItemCount]);

  return (
    <motion.div
      initial={isToastVisible}
      animate={isToastVisible ? 'visible' : 'hidden'}
      variants={{
        visible: { opacity: 1, height: 'auto' },
        hidden: { opacity: 0 },
      }}
      transition={{ delay: 0.2, duration: 0.3, ease: 'easeOut' }}
      aria-hidden={!isToastVisible}
    >
      <Wrapper py="6px" px="12px" backgroundColor="warmWhite3">
        <P variant="standard-semi-bold">Added to your order</P>
      </Wrapper>
    </motion.div>
  );
};

const Wrapper = styled(Flex)`
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  white-space: nowrap;
  border-radius: 3.75px;
`;

const ObservedAddedToOrderToast = observer(AddedToOrderToast);
export { ObservedAddedToOrderToast as AddedToOrderToast };
